<template>
  <b-row>
    <b-col v-for="card in cards" :key="card.title" cols="6" md="3" class="mb-1">
      <b-card class="mb-0 h-100">
        <div class="d-flex align-items-center">
          <b-avatar size="48" :variant="`light-${card.variant}`">
            <feather-icon :icon="card.icon" size="22" />
          </b-avatar>
          <div class="ml-1">
            <small class="text-muted d-block">{{ card.title }}</small>
            <h4 class="mb-0">{{ card.value }}</h4>
            <small class="text-muted">{{ card.subtitle }}</small>
          </div>
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow, BCol, BCard, BAvatar,
} from 'bootstrap-vue'
import { computed } from '@vue/composition-api'
import { formatRub, formatPercent, formatRoi } from '@/views/finance/utils'

const formatInt = value => (value == null ? '—' : String(value))

const formatAvgGames = value => {
  if (value == null) return '—'
  return Number(value).toFixed(1).replace('.', ',')
}

export default {
  components: { BRow, BCol, BCard, BAvatar },
  props: {
    summary: { type: Object, default: null },
  },
  setup(props) {
    const cards = computed(() => {
      const s = props.summary || {}
      return [
        {
          title: 'Пакетов',
          value: formatInt(s.packs_count),
          subtitle: '',
          icon: 'LayersIcon',
          variant: 'primary',
        },
        {
          title: 'Окупились',
          value: formatInt(s.paid_off_count),
          subtitle: `Доля: ${formatPercent(s.paid_off_share)}`,
          icon: 'CheckCircleIcon',
          variant: 'success',
        },
        {
          title: 'ROI средний',
          value: formatRoi(s.avg_roi),
          subtitle: `Прибыль: ${formatRub(s.total_profit)}`,
          icon: 'TrendingUpIcon',
          variant: 'info',
        },
        {
          title: 'ROI медианный',
          value: formatRoi(s.median_roi),
          subtitle: `Игр в среднем: ${formatAvgGames(s.avg_games_per_pack)}`,
          icon: 'BarChart2Icon',
          variant: 'secondary',
        },
      ]
    })

    return { cards }
  },
}
</script>
